import { useCallback, useTransition } from 'react';
import useNotification from '@/hooks/useNotification';
import useTranslations from '@/hooks/useTranslations';

import unCompanyFavouriteCarpiProductConfiguration from '@/actions/productWorkflow/carpi/productConfiguration/uncompanyFavouriteCarpiProductConfiguration';
import useAuth from '@/lib/firebase/auth/store';

export default function useCompanyUnfavouriteDialog({
  id,
  product,
}: {
  id: string;
  product: string;
}) {
  const [, startCompanyUnfavouriting] = useTransition();
  const notifications = useNotification();
  const { t, locale } = useTranslations();
  const { userData } = useAuth();
  const companyId = userData.company.id;

  const handleCompanyUnfavouritingDialog = useCallback(async () => {
    const onConfirm = async () => {
      startCompanyUnfavouriting(async () => {
        return unCompanyFavouriteCarpiProductConfiguration(id, locale, companyId)
          .then(() => {
            notifications.success(t('product.workflow.companyUnfavourite.success'));
          })
          .catch((error) => {
            console.log(error);
            notifications.error(t('product.workflow.companyUnfavourite.error'));
          });
      });
    };

    return notifications.dialog({
      title: t('product.workflow.companyUnfavourite.title'),
      message: t('product.workflow.companyUnfavourite.message', { product }),
      severity: 'error',
      confirmText: t('product.workflow.companyUnfavourite.confirmText'),
      onConfirm,
    });
  }, [notifications, t, id, locale, companyId, product]);

  return {
    handleCompanyUnfavouritingDialog,
  };
}
